<template>
  <h1 class="text-xl font-semibold mb-4"><slot /></h1>
</template>
